export default __webpack_public_path__ + "static/modal-thankyou-8febe7327f3bbed3336e86aeb0c39927.jpg";